export const SITE_DISCORD = 'https://discord.gg/kffdpSp6Ar';
export const SITE_EMAIL = 'contact@treasonps.com';
